import Marquee from "react-fast-marquee";

const WORDS = [
  "RESIDENTIAL",
  "COMMERCIAL",
  "INTERIOR",
  "EXTERIOR",
  "MONTGOMERY AL",
  "SAME-DAY QUOTES",
];

export default function EditorialMarquee() {
  return (
    <section
      data-testid="marquee-section"
      className="py-10 md:py-14 border-y border-brand-border bg-brand-bg overflow-hidden"
    >
      <Marquee gradient={false} speed={45} pauseOnHover={false}>
        {WORDS.concat(WORDS).map((w, i) => (
          <span
            key={i}
            className="font-display text-[11vw] md:text-[9vw] leading-none uppercase text-stroke mx-8 tracking-tight"
          >
            {w} <span className="text-brand-blue mx-4">◆</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
